import {
  BaseQueryApi,
  QueryReturnValue,
  type BaseQueryFn,
} from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import {
  type FetchArgs,
  type FetchBaseQueryError,
  type FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query/fetchBaseQuery";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CasdoorSDK } from "shared/libs/casdoor/config";

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {},
  FetchBaseQueryMeta
> = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_URI,
  prepareHeaders: (headers) => {
    headers.set("Authorization", `${localStorage.getItem("token")}`);
  },
});

const AUTH_ERROR_CODES = new Set([401]);

export async function baseQueryWithReauth(
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: {}
): Promise<QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>> {
  const result = await baseQuery(args, api, extraOptions);
  if (
    result.error &&
    typeof result.error.status === "number" &&
    AUTH_ERROR_CODES.has(result.error.status)
  ) {
    localStorage.removeItem("token");
    CasdoorSDK.signin_redirect();
  }

  return result;
}
